import { FC } from 'react';
import styled from '@emotion/styled';
import rem from '../../../utils/rem/rem';

interface CharacterCountProps {
  charactersRemaining: number;
}

const StyledCharacterCount = styled.div`
  font-size: ${rem(12)};
`;

const CharacterCount: FC<CharacterCountProps> = ({ charactersRemaining }) => {
  const ending = charactersRemaining === 1 ? 'character remaining' : 'characters remaining';
  return <StyledCharacterCount aria-live='polite'>{`${charactersRemaining} ${ending}`}</StyledCharacterCount>;
};

export default CharacterCount;
